import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import navReducer from '../features/navigation/navSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    nav: navReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;